export const combinedLanguageCharacterSet = Object.values({
  basicLatin: "A-Za-z",
  polish: "ĄąĆćĘęŁłŃńÓóŚśŹźŻż",
  czech: "ÁáČčĎďÉéĚěÍíŘřŠšŤťÚúŮůÝýŽž",
  german: "ÄäÖöÜüẞß", // covers finnish
  french: "ÀàÂâÆæÇçÉéÈèÊêËëÎîÏïÔôŒœÙùÛûÜüŸÿ",
  italian: "ÀàÈèÉéÌìÒòÓóÙùÇç",
  spanish: "ÁáÉéÍíÑñÓóÚúÜü",
  turkish: "ÇçĞğİıÖöŞşÜü",
  danish: "ÆæØøÅå", // covers norwegian, swedish
}).join("");
